import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "confirmation-popup__error"
}

import { ref } from 'vue'

import BasePopup from '@/components/ui/BasePopup.vue'
import AppButton from '@/app/components/button/AppButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmationPopup',
  props: {
    title: {},
    onCancel: { type: Function },
    onConfirm: { type: Function },
    danger: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const basePopup = ref<InstanceType<typeof BasePopup> | null>(null)
const currentlyLoadingButton = ref<'cancel' | 'confirm' | null>(null)
const showError = ref(false)

async function handleClick(buttonType: 'cancel' | 'confirm'): Promise<void> {
  showError.value = false
  currentlyLoadingButton.value = buttonType

  const success =
    buttonType === 'confirm' ? await props.onConfirm() : await props.onCancel()

  if (success) {
    basePopup.value?.hide()
  } else {
    showError.value = true
  }

  currentlyLoadingButton.value = null
}

function show(): void {
  basePopup.value?.show()
}

__expose({ show })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasePopup, {
    ref_key: "basePopup",
    ref: basePopup,
    title: __props.title,
    class: "confirmation-popup"
  }, {
    buttons: _withCtx(() => [
      _createVNode(AppButton, {
        class: "confirmation-popup__btn confirmation-popup__btn--cancel",
        outlined: true,
        loading: currentlyLoadingButton.value === 'cancel',
        disabled: currentlyLoadingButton.value !== null,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClick('cancel')))
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "cancel", {}, () => [
            _cache[2] || (_cache[2] = _createTextVNode("Cancel", -1))
          ])
        ]),
        _: 3
      }, 8, ["loading", "disabled"]),
      _createVNode(AppButton, {
        class: "confirmation-popup__btn confirmation-popup__btn--confirm",
        loading: currentlyLoadingButton.value === 'confirm',
        disabled: currentlyLoadingButton.value !== null,
        danger: __props.danger,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClick('confirm')))
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "confirm", {}, () => [
            _cache[3] || (_cache[3] = _createTextVNode("Confirm", -1))
          ])
        ]),
        _: 3
      }, 8, ["loading", "disabled", "danger"])
    ]),
    default: _withCtx(() => [
      (_ctx.$slots.default)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
            _renderSlot(_ctx.$slots, "default")
          ]))
        : _createCommentVNode("", true),
      (showError.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, " An unexpected error ocurred. Please try again later. "))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["title"]))
}
}

})